module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'driver',
        preventClearOnCancel: true,
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bosch_drivers': true,
        },
    },
}